export default "__VITE_ASSET__C_7r8UoU__"